module.exports = __webpack_public_path__ + "img/facebook.0bac06d2.svg";